/* eslint-disable no-case-declarations */
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import { useFormContext } from 'react-hook-form';

import NumberText from 'components/elements/numberText';
// import { useGlobalStore } from 'lib/DataStore';
import { semanticFilterBox } from 'components/modules/plp/constant';
import { NewPlpTypes } from 'lib/apis/services/NewPlpListiing';

export const GenerateTitle = ({
  item,
  isActive = false,
}: {
  item: NewPlpTypes.SemanticFilterItems;
  isActive: boolean;
}) => {
  // const { userDevice } = useGlobalStore();
  // const { data: semanticFilterBox } =
  //   NewPlpService.useNewFilterBoxSemanticQuery(userDevice);
  const { watch } = useFormContext();
  let newData = watch();
  if (!isActive) return <>{item.title}</>;

  switch (item.type) {
    case 'ArrayNumber':
    case 'ONE_SELECTED':
      const field = find(
        semanticFilterBox,
        (input) => input.fieldName === item.fieldName
      );
      if (!field) return <>None</>;
      if (field.type === 'ArrayNumber') {
        if (isEmpty(newData[item.fieldName])) {
          return (
            <>
              {
                (field.values as NewPlpTypes.ArrayNumberFilterValueType[])[0].name
              }
            </>
          );
        }
        const filedValue = find(
          field.values as NewPlpTypes.ArrayNumberFilterValueType[],
          (val) =>{
            if(Array.isArray(newData[item.fieldName])){
              return val.id === (newData[item.fieldName] as string[])[0]
            }
            else {
              return val.id === newData[item.fieldName];
            }

          }
        )
        if (!filedValue) return <>None</>;
        return (
          <>
            {`${filedValue.name}` +
              (Array.isArray(newData[item.fieldName])&&(newData[item.fieldName] as string[]).length  - 1 >= 1
                ? ` +${(newData[item.fieldName] as string[]).length - 1}`
                : '')}
          </>
        );
      }
      else {
        const filedValue = find(
          field.values as NewPlpTypes.ArrayNumberFilterValueType[],
          (val) => val.id === (newData[item.fieldName] as string)
        );
        if (!filedValue) return <>None</>;
        return <>{filedValue.name}</>;
      }
    case 'INTEGER':
      let title:string;
      if(item.fieldName === "floor"){
        title = "طبقه";
      }
      else {
        title = "اتاق";
      }
      if (!newData[`${item.fieldName}Exact`])
        return <>بیشتر از {newData[item.fieldName]} {title}</>;
      return <>{newData[item.fieldName]} {title}</>;
    case 'RANGE':
      if (
        (newData[item.fieldName] as NewPlpTypes.RangeValue).max &&
        !(newData[item.fieldName] as NewPlpTypes.RangeValue).min
      ) {
        return (
          <>
            حداکثر{' '}
            <NumberText>
              {(
                newData[item.fieldName] as NewPlpTypes.RangeValue
              ).max?.toString()}
            </NumberText>
            &nbsp;
            {(item.values as NewPlpTypes.RangeFilterValueType).unit}
          </>
        );
      } else if (
        !(newData[item.fieldName] as NewPlpTypes.RangeValue).max &&
        (newData[item.fieldName] as NewPlpTypes.RangeValue).min
      ) {
        return (
          <>
            حداقل{' '}
            <NumberText>
              {(
                newData[item.fieldName] as NewPlpTypes.RangeValue
              ).min?.toString()}
            </NumberText>
            &nbsp;
            {(item.values as NewPlpTypes.RangeFilterValueType).unit}
          </>
        );
      } else {
        return (
          <>
            <span>
              <NumberText>
                {(
                  newData[item.fieldName] as NewPlpTypes.RangeValue
                ).min?.toString()}
              </NumberText>
              &nbsp;
              {(item.values as NewPlpTypes.RangeFilterValueType).unit}
            </span>
            <span> - </span>
            <span>
              <NumberText>
                {(
                  newData[item.fieldName] as NewPlpTypes.RangeValue
                ).max?.toString()}
              </NumberText>
              &nbsp;
              {(item.values as NewPlpTypes.RangeFilterValueType).unit}
            </span>
          </>
        );
      }
    default:
      return <></>;
  }
};
